import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  Paper,
  Typography,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Menu,
  MenuItem,
  InputAdornment,
  Select,
  ListItemIcon,
  Checkbox,
  ListItemText,
  FormControl,
  OutlinedInput,
  withStyles,
} from '@material-ui/core';

import * as Icons from '@material-ui/icons';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../../utils/common';
import ModuleForm from './Dialog/ModuleForm';
import WarningForm from './Dialog/WarningForm';

class Module extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      rowIndex: null,
      expand: null,
      openMenu: null,
      dialogModuleForm: {
        groupId: null,
        name: null,
        open: false,
      },
      dialogWarningForm: {
        groupId: null,
        subgroupIndex: null,
        name: null,
        open: false,
      },
      isChanged: false,
      isAllSelected: false,
      defaultOrganizations: [],
      organizations: [],
      groups: [],
      selected: [],
      searchText: '',
      searchGroup: '',
    };
  }

  async componentDidMount() {
    console.log('componentDidMount from module');
    const { tenantId } = this.props.tenant.toJS();
    if (tenantId) {
      const tenantIds = [tenantId];
      this.initOrganizationData(tenantIds);
      await this.props.maps.getMapByTenantId(tenantId);
    }
  }

  async initOrganizationData(tenantIds) {
    const groups = await this.props.group.getGroupList(tenantIds);
    const groupIds = (groups || []).map((g) => g.id);
    let organizations = await this.props.subGroup.getSubgroupByGroupIds(groupIds);

    groups.forEach((g) => {
      organizations = (organizations || []).map((data) => {
        if (g.id === data.groupId) {
          data.groupName = g.name;
          if (data.subgroups.length > 0) {
            data.subgroups.map((s) => {
              s.isChange = false;
              return s;
            });
          }
        }
        return data;
      });
    });
    const reformGroupData = (groups || []).map((g) => g.name);
    this.setState({
      organizations,
      defaultOrganizations: organizations,
      groups: reformGroupData,
    });
  }

  validateChangData = (organizations) => {
    const isChangeData = (organizations || []).filter((organization) => {
      if (organization.subgroups && organization.subgroups.length > 0) {
        return organization.subgroups.find((subgroup) => subgroup.isChange === true);
      }
      return false;
    });
    return isChangeData.length > 0 ? true : false;
  };

  handleFinished = () => {
    const { t } = this.props;
    const { organizations, isChanged } = this.state;
    const isValid = this.validateChangData(organizations);
    const tenantStep = 1;
    if (isValid || isChanged) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();

          this.handleSetNavigation(tenantStep);
          this.props.wizard.resetFlow();
          this.props.wizard.setActiveStep(tenantStep);
        }
      });
    } else {
      this.handleSetNavigation(tenantStep);
      this.props.wizard.resetFlow();
      this.props.wizard.setActiveStep(tenantStep);
    }
  };

  handleBack = () => {
    const { t } = this.props;
    const { activeStep } = this.props.wizard.toJS();
    const unitStep = 2;
    const { isChanged } = this.state;
    if (isChanged) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();

          this.handleSetNavigation(unitStep);
          this.props.wizard.backStep(activeStep);
          this.props.wizard.setActiveFlow('group');
        }
      });
    } else {
      this.handleSetNavigation(unitStep);
      this.props.wizard.backStep(activeStep);
      this.props.wizard.setActiveFlow('group');
    }
  };

  handleSave = async () => {
    const { t } = this.props;
    const { organizations } = this.state;
    const { tenantId } = this.props.tenant.toJS();
    const foundEmptyName = (organizations || []).filter((organization) => {
      if (organization.subgroups && organization.subgroups.length > 0) {
        return organization.subgroups.find((subgroup) => subgroup.name === '');
      }
      return false;
    });

    // reformat data
    // let changeGroupData = (organizations || []).filter(group => {
    //   const foundChangeData = group.subgroups.find(subgroup => subgroup.isChange === true);
    //   if (foundChangeData) {
    //     return group;
    //   }
    //   return false;
    // }).map(data => {
    //   return {
    //     groupId: data.groupId,
    //     subgroups: data.subgroups.map(s => {
    //       return {
    //         id: s.id,
    //         name: s.name,
    //         mapId: s.mapId,
    //         tenantId: s.tenantId,
    //         groupId: s.groupId,
    //       }
    //     }),
    //   }
    // });
    let changeGroupData = (organizations || []).map((data) => {
      return {
        groupId: data.groupId,
        subgroups: data.subgroups.map((s) => {
          return {
            id: s.id,
            name: s.name,
            mapId: s.mapId,
            tenantId: s.tenantId,
            groupId: s.groupId,
          };
        }),
      };
    });

    if (foundEmptyName.length > 0) {
      Swal.fire({
        html: `<h4>This is a required Module Name.`,
        type: 'warning',
      });
    } else {
      try {
        const result = await this.props.subGroup.updateSubgroups(changeGroupData);
        if (result.statusCode === 200) {
          this.setState({ isChanged: false });
          this.initOrganizationData([tenantId]);
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_update')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
        }
      }
    }
  };

  handleDelete = () => {
    const { organizations, dialogWarningForm } = this.state;
    const results = organizations.map((organization) => {
      if (dialogWarningForm.groupId === organization.groupId) {
        organization.subgroups = organization.subgroups.filter((s, i) => i !== dialogWarningForm.subgroupIndex);
      }
      return organization;
    });

    this.setState({
      organizations: results,
      defaultOrganizations: results,
      isChanged: true,
    });

    this.handleCloseWarningForm();
  };

  handleResetData = () => {
    const { tenantId } = this.props.tenant.toJS();
    this.initOrganizationData([tenantId]);
    this.setState({ isChanged: false });
  };

  handleOpendWarningForm = (groupId, index, name) => {
    this.setState({
      dialogWarningForm: {
        groupId,
        name,
        subgroupIndex: index,
        open: true,
      },
    });
  };

  handleCloseWarningForm = () => {
    this.setState({
      dialogWarningForm: {
        ...this.state.dialogWarningForm,
        groupId: null,
        subgroupIndex: null,
        open: false,
      },
    });
  };

  handleSearch = (e) => {
    const { value } = e.target;
    this.setState({ searchText: value });

    const search = value && value.toLowerCase();
    // const { groups } = this.props.group.toJS();
    const { defaultOrganizations } = this.state;
    let searchResult = defaultOrganizations;

    if (search && search.length > 0) {
      const tmp = (defaultOrganizations || []).filter((organization) => {
        if (organization.groupName.toLowerCase().includes(search)) {
          return true;
        } else if (organization.subgroups && organization.subgroups.length > 0) {
          return organization.subgroups.find((subgroup) => subgroup.name.toLowerCase().includes(search));
        }
        return false;
      });

      searchResult = tmp;
    }

    this.setState({ organizations: searchResult });
  };

  handleChangeMap = (e, subgroupId, groupId) => {
    const { organizations } = this.state;
    const { value } = e.target;
    const newRows = organizations.map((row) => {
      if (groupId === row.groupId && row.subgroups.length > 0) {
        row.subgroups.map((subgroup) => {
          if (subgroup.id === subgroupId) {
            subgroup.mapId = value;
            subgroup.isChange = true;
          }
          return subgroup;
        });
      }
      return row;
    });

    this.setState({
      isChanged: true,
      organizations: [...newRows],
      defaultOrganizations: [...newRows],
    });
  };

  handleUnlink = (subgroupId, groupId) => {
    const { organizations } = this.state;
    const newRows = organizations.map((row) => {
      if (groupId === row.groupId && row.subgroups.length > 0) {
        row.subgroups.map((subgroup) => {
          if (subgroup.id === subgroupId) {
            subgroup.mapId = null;
            subgroup.isChange = true;
          }
          return subgroup;
        });
      }
      return row;
    });

    this.setState({
      isChanged: true,
      organizations: [...newRows],
      defaultOrganizations: [...newRows],
    });
  };

  handleChange = (e, subgroupId, groupId) => {
    const { organizations } = this.state;
    const { value } = e.target;
    const newRows = organizations.map((row) => {
      if (groupId === row.groupId && row.subgroups.length > 0) {
        row.subgroups.map((subgroup) => {
          if (subgroup.id === subgroupId) {
            subgroup.name = value;
            subgroup.isChange = true;
            // return { ...subgroup, [name]: value, isChange: true };
          }
          return subgroup;
        });
      }
      return row;
    });

    this.setState({
      isChanged: true,
      organizations: [...newRows],
      defaultOrganizations: [...newRows],
    });
  };

  handleFocus = (index) => {
    this.setState({ rowIndex: index });
  };

  handleUnFocus = () => {
    this.setState({ rowIndex: null });
  };

  handleExpand = async (group) => {
    this.setState({
      expand: this.state.expand !== group.groupId ? group.groupId : null,
    });
  };

  handleOpenModuleForm = (id, name) => {
    this.setState({
      dialogModuleForm: {
        id,
        name,
        open: true,
      },
    });
    const modules = [{ name: '' }];
    this.props.subGroup.setModules(modules);
  };

  handleCloseModuleForm = () => {
    this.setState({
      dialogModuleForm: {
        open: false,
      },
    });
  };

  handleOpenMenu = async (event, subgroup, group) => {
    this.setState({
      openMenu: event.currentTarget,
    });
    this.props.subGroup.changeData('moduleId', subgroup.id);
    this.props.subGroup.changeData('name', subgroup.name);
    this.props.maps.setAction('mapId', subgroup.mapId);
    this.props.group.setAction('groupId', group.groupId);
    this.props.group.setAction('groupName', group.groupName);
  };

  handleCloseMenu = () => {
    this.setState({
      openMenu: null,
    });
  };

  handleSubmitCreate = async (id, modules) => {
    const { t } = this.props;
    try {
      const result = await this.props.subGroup.createMultipleSubgroups(id, modules);
      if (result.statusCode === 200) {
        const { tenantId } = this.props.tenant.toJS();
        if (tenantId) {
          const tenantIds = [tenantId];
          this.initOrganizationData(tenantIds);
        }
        this.handleCloseModuleForm();
      }
    } catch (error) {
      Swal.fire({
        html: `<h4>${t('failed_to_create')}`,
        confirmButtonText: `${t('ok')}`,
        type: 'warning',
        customClass: {
          container: 'my-swal',
        },
      });
    }
  };

  handleSelect = (e) => {
    const { value } = e.target;
    let { selected, groups, defaultOrganizations } = this.state;
    if (value[value.length - 1] === 'all') {
      const data = selected.length === groups.length ? [] : groups;
      this.setState({ selected: data, organizations: defaultOrganizations });
    } else if (value[value.length - 1] !== '') {
      // filter organizations
      const tmp = (defaultOrganizations || []).filter((ogn) =>
        value.length > 0 ? value.includes(ogn.groupName) : true,
      );
      this.setState({ selected: value, organizations: tmp });
    }
  };

  handleSearchMenuItem = (e) => {
    const { value } = e.target;
    this.setState({ searchGroup: value });

    const search = value && value.toLowerCase();
    const { groups } = this.props.group.toJS();
    let searchResult = (groups || []).map((g) => g.name);

    if (search && search.length > 0) {
      const tmp = (searchResult || []).filter((data) => {
        if (data.toLowerCase().includes(search)) {
          return true;
        }
        return false;
      });

      searchResult = tmp;
    }

    this.setState({ groups: searchResult });
  };

  handleClickNextPage = (task) => {
    this.handleCloseMenu();
    const { t } = this.props;
    const { activeStep } = this.props.wizard.toJS();
    const { isChanged } = this.state;
    if (isChanged) {
      Swal.fire({
        html: `<h4>${t('wizard_ask_save_change')}`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: `${t('cancel')}`,
        confirmButtonText: `${t('save')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.handleSave();

          this.handleNavigation();
          if (task === 'bed') {
            this.props.wizard.setActiveFlow('bed');
          } else if (task === 'device') {
            this.props.wizard.setActiveFlow('device');
          } else if (task === 'map') {
            this.props.wizard.setActiveFlow('map');
          }
          this.props.wizard.nextStep(activeStep);
        }
      });
    } else {
      this.handleNavigation();
      if (task === 'bed') {
        this.props.wizard.setActiveFlow('bed');
      } else if (task === 'device') {
        this.props.wizard.setActiveFlow('device');
      } else if (task === 'map') {
        this.props.wizard.setActiveFlow('map');
      }
      this.props.wizard.nextStep(activeStep);
    }
  };

  handleSetNavigation = (step) => {
    const { navigations } = this.props.wizard.toJS();
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
  };

  handleNavigation = () => {
    const { data } = this.props.subGroup.toJS();
    const { groupName } = this.props.group.toJS();
    const { navigations, activeStep } = this.props.wizard.toJS();
    // wizard name
    navigations.forEach((nav) => {
      if (nav.wizardPage === 'unit') {
        nav.wizardName = groupName;
      }
    });

    // set nav module
    const tmp = {
      wizardStep: activeStep,
      wizardPage: 'module',
      wizardName: data.name,
    };
    navigations.push(tmp);
    this.props.wizard.setNavigation(navigations);
  };

  goToPage = (data) => {
    this.props.wizard.setActiveStep(data.wizardStep);

    const { navigations } = this.props.wizard.toJS();
    const nav = navigations.filter((nav) => nav.wizardStep < data.wizardStep);
    this.props.wizard.setNavigation(nav);
  };

  render() {
    const { classes, t } = this.props;
    const { rowIndex, expand, organizations, searchText, selected, groups } = this.state;
    const { mapsInfo, mapId } = this.props.maps.toJS();
    const { navigations } = this.props.wizard.toJS();
    const isAllSelected = groups.length > 0 && selected.length === groups.length;

    return (
      <div>
        <Grid container item sm={12}>
          {(navigations || []).map((nav, i) => (
            <div id={nav.wizardPage} className={classes.nav} key={i} onClick={() => this.goToPage(nav)}>
              {' '}
              {t(`${nav.wizardName}`)}
              {' > '}
            </div>
          ))}
          <div className={classes.activeNav}>{t('wizard_step_module')}</div>
        </Grid>
        <Grid container item sm={12}>
          <div className={classes.textHeader}>{t('wizard_module_for')}</div>
          <div className={classes.textHeaderPrimary}>{t('wizard_step_unit_s')}</div>
        </Grid>
        <Grid container item spacing={8}>
          <Grid item xs={12} sm={4}>
            <FormControl variant='outlined' fullWidth className={classes.formSelect}>
              <Select
                multiple
                id='select'
                name='select'
                margin='dense'
                fullWidth
                value={selected}
                onChange={(e) => this.handleSelect(e)}
                renderValue={(selected) => selected.join(', ')}
                className={classes.Contentselect}
                startAdornment={
                  <InputAdornment position='start' style={{ width: '60%' }}>
                    <Typography style={{ color: '#A8A8A8', fontSize: 16 }}>{t('wizard_step_unit')}:</Typography>
                  </InputAdornment>
                }
                MenuProps={{
                  classes: { paper: classes.menuPaper },
                }}
                input={<OutlinedInput labelWidth={0} name='movementLevel' id='outlined-movementLevel' margin='dense' />}
              >
                <TextField
                  id='search'
                  name='search'
                  variant='outlined'
                  margin='dense'
                  fullWidth
                  value={this.state.searchGroup}
                  placeholder={t('wizard_search_by_organization')}
                  onChange={(e) => this.handleSearchMenuItem(e)}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                    startAdornment: (
                      <InputAdornment position='start'>
                        {' '}
                        <svg width='24' height='24' viewBox='0 0 24 24'>
                          <use xlinkHref={`/images/menus-v1.svg#search`} />
                        </svg>
                      </InputAdornment>
                    ),
                  }}
                />
                <MenuItem value='all'>
                  <ListItemIcon>
                    <Checkbox color='primary' checked={isAllSelected} />
                  </ListItemIcon>
                  <ListItemText primary={t('select_all')} />
                </MenuItem>
                {groups.map((g, i) => (
                  <MenuItem key={i} value={g}>
                    <ListItemIcon>
                      <Checkbox color='primary' checked={selected.indexOf(g) > -1} />
                    </ListItemIcon>
                    <ListItemText primary={g} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={8}>
            <TextField
              id='search'
              name='search'
              variant='outlined'
              margin='dense'
              fullWidth
              value={searchText || ''}
              placeholder={t('wizard_search_by_organization_and_module')}
              onChange={(e) => this.handleSearch(e)}
              className={classes.textField}
              InputProps={{
                className: classes.input,
                startAdornment: (
                  <InputAdornment position='start'>
                    {' '}
                    <svg width='24' height='24' viewBox='0 0 24 24'>
                      <use xlinkHref={`/images/menus-v1.svg#search`} />
                    </svg>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        <div style={{ overflow: 'auto', height: '60vh' }}>
          {(organizations || []).map((group) => (
            <Grid item xs={12} sm={12} style={{ marginTop: 20 }} key={group.groupId}>
              <Grid
                container
                item
                xs={12}
                sm={12}
                alignItems='center'
                className={expand === group.groupId ? classes.boxContentExpands : classes.boxContentCollapse}
              >
                <Grid
                  container
                  item
                  xs={12}
                  sm={6}
                  md={8}
                  onClick={() => this.handleExpand(group)}
                  id={`expland-${group.groupId}`}
                >
                  <div className={expand === group.groupId ? classes.iconExpands : classes.iconCollapse}>
                    <svg width='15' height='8' viewBox='0 0 15 8'>
                      <use xlinkHref={`/images/toolbar.svg#dropdown`} />
                    </svg>
                  </div>
                  <Typography className={classes.textTitle}>{group.groupName}</Typography>
                </Grid>

                <Grid item xs={12} sm={6} md={4} className={classes.wrapButton}>
                  <Button
                    id={`create-${group.groupId}`}
                    variant='contained'
                    style={{
                      backgroundColor: '#009D9A',
                      color: '#fff',
                      borderRadius: 8,
                    }}
                    onClick={() => this.handleOpenModuleForm(group.groupId, group.groupName)}
                  >
                    <div style={{ marginRight: 5 }}>
                      <svg width='24' height='24' viewBox='0 0 24 24' style={{ fill: '#fff' }}>
                        <use xlinkHref={`/images/menus-v1.svg#add-circle`} />
                      </svg>
                    </div>
                    {t('create_a_module')}
                  </Button>
                </Grid>
              </Grid>

              {expand === group.groupId && (
                <Grid item xs={12} sm={12}>
                  <Paper className={classes.paperTable}>
                    <Table>
                      <TableHead>
                        <TableRow style={{ border: 'none', height: 40 }}>
                          <CustomTableCell>{t('wizard_module_name')}</CustomTableCell>
                          <CustomTableCell style={{ width: 250 }}>{t('wizard_map_name')}</CustomTableCell>
                          <CustomTableCell>{t('wizard_module_no_of_beds')}</CustomTableCell>
                          <CustomTableCell>{t('wizard_module_no_of_devices')}</CustomTableCell>
                          <CustomTableCell>{t('action')}</CustomTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {group.subgroups.length > 0 &&
                          group.subgroups.map((subgroup, i) => (
                            <TableRow key={i}>
                              <CustomTableCell component='th' scope='row' style={{ width: 250 }}>
                                <TextField
                                  id={`name-${subgroup.id}`}
                                  name='name'
                                  variant='outlined'
                                  margin='dense'
                                  fullWidth
                                  value={subgroup.name || ''}
                                  onChange={(e) => this.handleChange(e, subgroup.id, group.groupId)}
                                  onFocus={() => this.handleFocus(i)}
                                  onBlur={() => this.handleUnFocus()}
                                  className={classes.textField}
                                  InputProps={{
                                    className: rowIndex === i ? classes.input : classes.inputNoBorder,
                                    readOnly: rowIndex !== i,
                                  }}
                                />
                              </CustomTableCell>
                              <CustomTableCell
                                component='th'
                                scope='row'
                                // style={{ maxWidth: 280, width: 280 }}
                              >
                                <Grid
                                  container
                                  item
                                  xs={12}
                                  sm={12}
                                  alignItems='center'
                                  className={classes.widthAction}
                                >
                                  <TextField
                                    select
                                    id={`select-map-${subgroup.id}`}
                                    name='select-map'
                                    variant='outlined'
                                    margin='dense'
                                    value={subgroup.mapId || 0}
                                    onChange={(e) => this.handleChangeMap(e, subgroup.id, group.groupId)}
                                    className={classes.textField}
                                    InputProps={{
                                      className: classes.input,
                                    }}
                                    style={{
                                      width: '82%',
                                      marginRight: 10,
                                    }}
                                  >
                                    <MenuItem value={0} disabled>
                                      <Typography style={{ color: '#BDBDBD' }}>{t('select_map')}</Typography>
                                    </MenuItem>
                                    {mapsInfo.map((map) => (
                                      <MenuItem key={map.id} value={map.id} id={map.name}>
                                        {map.name}
                                      </MenuItem>
                                    ))}
                                  </TextField>
                                  {subgroup.mapId && (
                                    <svg
                                      id={`unlink-${subgroup.id}`}
                                      width='32'
                                      height='32'
                                      viewBox='0 0 32 32'
                                      className={classes.btnIcon}
                                      onClick={() => this.handleUnlink(subgroup.id, group.groupId)}
                                    >
                                      <use xlinkHref={`/images/menus-v1.svg#unlink`} />
                                    </svg>
                                  )}
                                </Grid>
                              </CustomTableCell>
                              <CustomTableCell component='th' scope='row'>
                                {subgroup.beds.length}
                              </CustomTableCell>
                              <CustomTableCell component='th' scope='row'>
                                {subgroup.devices.length}
                              </CustomTableCell>
                              <CustomTableCell component='th' scope='row'>
                                <Grid
                                  container
                                  alignItems='center'
                                  className={classes.widthAction}
                                  style={{ width: 160 }}
                                >
                                  <Button
                                    id={`manage-${subgroup.id}`}
                                    variant='outlined'
                                    color='primary'
                                    style={{ marginRight: 10 }}
                                    onClick={(e) => this.handleOpenMenu(e, subgroup, group)}
                                  >
                                    {t('manage')}
                                    <Icons.ArrowRight />
                                  </Button>
                                  <IconButton
                                    id={`delete-${subgroup.id}`}
                                    className={classes.btnIcon}
                                    onClick={() => this.handleOpendWarningForm(group.groupId, i, subgroup.name)}
                                    disabled={subgroup.beds.length > 0 || subgroup.devices.length > 0 ? true : false}
                                  >
                                    <svg width='24' height='24' viewBox='0 0 16 16'>
                                      <use xlinkHref={`/images/menus-v1.svg#trash`} />
                                    </svg>
                                  </IconButton>
                                </Grid>
                              </CustomTableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </Paper>
                </Grid>
              )}
            </Grid>
          ))}
        </div>

        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <Button
              id='back'
              variant='outlined'
              color='primary'
              style={{ marginRight: 10 }}
              onClick={this.handleBack}
              className={classes.btnPrimary}
            >
              {t('back')}
            </Button>
          </div>
          <div style={{ display: 'flex' }}>
            {this.state.isChanged && (
              <Button
                id='reset'
                variant='outlined'
                color='primary'
                onClick={this.handleResetData}
                className={classes.btnPrimary}
                style={{ marginRight: 10 }}
              >
                {t('wizard_reset_data')}
              </Button>
            )}
            {this.state.isChanged && (
              <Button
                id='save'
                variant='outlined'
                color='primary'
                style={{ marginRight: 10 }}
                className={classes.btnPrimary}
                onClick={this.handleSave}
              >
                {t('save')}
              </Button>
            )}
            <Button
              id='finish'
              variant='contained'
              color='primary'
              onClick={this.handleFinished}
              className={classes.btnPrimary}
            >
              {t('wizard_finish')}
            </Button>
          </div>
        </Grid>

        <ModuleForm
          open={this.state.dialogModuleForm.open}
          data={this.state.dialogModuleForm}
          handleCloseForm={this.handleCloseModuleForm}
          handleCreate={this.handleSubmitCreate}
        />

        <WarningForm
          open={this.state.dialogWarningForm.open}
          handleSubmitForm={this.handleDelete}
          handleCloseForm={this.handleCloseWarningForm}
          cancelButtonText={t('no')}
          confirmButtonText={t('confirm')}
          headerTitle={t('wizard_module_delete')}
          subTitle={t('wizard_module_delete_subtitle').replace('x', this.state.dialogWarningForm.name)}
        />

        <Menu
          id='selectManage'
          anchorEl={this.state.openMenu}
          open={Boolean(this.state.openMenu)}
          onClose={() => this.handleCloseMenu()}
          className={classes.gridMenu}
          disableAutoFocusItem
        >
          <MenuItem id='bed' onClick={() => this.handleClickNextPage('bed')}>
            <Typography>{t('wizard_step_bed')}</Typography>
          </MenuItem>
          <MenuItem id='device' onClick={() => this.handleClickNextPage('device')}>
            <Typography>{t('wizard_step_device')}</Typography>
          </MenuItem>
          <MenuItem id='map' onClick={() => this.handleClickNextPage('map')}>
            <Typography>{mapId ? t('wizard_manage_map') : t('create_map')}</Typography>
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.text.header,
    border: 'none',
    fontWeight: 500,
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      maxWidth: '200px',
    },
  },
  body: {
    fontSize: 16,
    borderTop: '1px solid #B8CFC3',
    borderBottom: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      width: '200px',
    },
  },
}))(TableCell);

const styles = (theme) => ({
  formSelect: {
    '& div': {
      color: theme.palette.primary.main,
      marginTop: 2,
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    minWidth: 130,
    maxWidth: '100%',
    position: 'relative',
  },
  Contentselect: {
    '& fieldset': {
      top: '2px',
      bottom: '6px',
    },
    '& svg': {
      top: 'calc(50% - 10px)',
    },
    '& div': {
      maxWidth: '200px',
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
      },
    },
  },
  menuPaper: {
    maxWidth: 300,
    maxHeight: 400,
    padding: 8,
    right: '45px !important',
  },
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  textHeaderPrimary: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 30,
    marginLeft: 5,
  },
  textTitle: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 20,
  },
  textSubTitle: {
    color: '#858585', //theme.palette.text.hint,
    fontWeight: 500,
    fontSize: 16,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  btnPrimary: {
    width: 180,
    borderRadius: '4px',
  },
  paperTable: {
    boxShadow: 'none',
    border: '1px solid #B8CFC3',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    position: 'relative',
    overflowX: 'auto',
    // borderRadius: "8px",
  },
  widthAction: {
    [theme.breakpoints.up('xl')]: {
      width: '320px',
    },
    [theme.breakpoints.down('lg')]: {
      width: '320px',
    },
    [theme.breakpoints.down('md')]: {
      width: '270px !important',
    },
  },
  textField: {
    fontWeight: 400,
    fontSize: 16,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
  inputNoBorder: {
    '& fieldset': {
      border: 'none !important',
    },
    color: theme.palette.text.primary,
    height: 40,
  },
  boxContentExpands: {
    backgroundColor: 'rgba(230, 244, 243, 0.5)',
    color: theme.palette.text.header,
    border: '1px solid #B8CFC3',
    borderBottom: 'none',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '10px 22px',
  },
  boxContentCollapse: {
    backgroundColor: 'rgba(230, 244, 243, 0.5)',
    color: theme.palette.text.header,
    border: '1px solid #B8CFC3',
    borderRadius: '8px',
    padding: '10px 22px',
  },
  iconExpands: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 16,
    transform: 'rotate(180deg)',
  },
  iconCollapse: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 16,
  },
  btnIcon: {
    borderRadius: 4,
    padding: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.bg,
    '&:hover': {
      fill: theme.palette.primary.bg,
      backgroundColor: theme.palette.primary.main,
    },
    '&:disabled': {
      fill: theme.palette.disable.main,
      backgroundColor: theme.palette.disable.light,
    },
    [theme.breakpoints.down('md')]: {
      marginRight: 5,
    },
  },
  nav: {
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    marginRight: 5,
  },
  activeNav: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
});

export const page = inject('wizard', 'tenant', 'group', 'subGroup', 'bed', 'device', 'maps')(observer(Module));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
